import {
  AppliedItem,
  MainTitle,
  RaffleContent,
  RaffleDay,
} from "../../../styles/theme";

import { CheckInConfirm } from "../../../system/types/Reservation";
import { X } from "@phosphor-icons/react";
import {
  SelectAccommodationStatus,
  SelectAccommodationText,
  AccommodationStatusIcon,
  AdminAccommodationInfoBox,
  ReportAfterUseBox,
} from "../../../styles/accommodationStyle";
import PhotoGallery from "../../Common/Photo/PhotoGallery";

interface CheckInModalProps {
  handleClose: () => void;
  data: CheckInConfirm;
}

function CheckInModalReport({ handleClose, data }: CheckInModalProps) {
  return (
    <>
      <RaffleContent>
        <MainTitle>입실 이전 휴양소 상태</MainTitle>
        <AppliedItem onClick={handleClose}>
          <X size={32} />
        </AppliedItem>
      </RaffleContent>
      {data && (
        <ReportAfterUseBox>
          <SelectAccommodationStatus>
            <RaffleDay>
              <AccommodationStatusIcon
                src={
                  data.condition === "GOOD"
                    ? "/images/SGOOD.png"
                    : "/images/GOOD.png"
                }
                alt="good"
              ></AccommodationStatusIcon>
              <SelectAccommodationText>최고예요</SelectAccommodationText>
            </RaffleDay>
            <RaffleDay>
              {" "}
              <AccommodationStatusIcon
                src={
                  data.condition === "SOSO"
                    ? "/images/SSOSO.png"
                    : "/images/SOSO.png"
                }
                alt="soso"
              ></AccommodationStatusIcon>
              <SelectAccommodationText>좋아요</SelectAccommodationText>
            </RaffleDay>
            <RaffleDay>
              <AccommodationStatusIcon
                src={
                  data.condition === "BAD"
                    ? "/images/SBAD.png"
                    : "/images/BAD.png"
                }
                alt="bad"
              ></AccommodationStatusIcon>
              <SelectAccommodationText>별로예요</SelectAccommodationText>
            </RaffleDay>
          </SelectAccommodationStatus>
          <SelectAccommodationText>
            기타의견
            <AdminAccommodationInfoBox>
              {data.opinions ? <pre>{data.opinions}</pre> : "-"}
            </AdminAccommodationInfoBox>
          </SelectAccommodationText>
          <PhotoGallery
            title="입실 전 사진"
            photos={data.attachmentFiles ?? []}
            emptyText="첨부한 사진이 없습니다"
          />
        </ReportAfterUseBox>
      )}
    </>
  );
}

export default CheckInModalReport;
